module.exports = __webpack_public_path__ + "media/images/enabled_procedure_managements/user_examples_mobile-0a80a82babd457b98ad57921e9e30d03.png";